import { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Grid, TextFieldProps } from '@mui/material';

import ControlledDatePicker from 'components/shared/ControlledFields/ControlledDatePicker';

type Props = TextFieldProps & {
  control: Control<any>;
  disabledValidFrom?: boolean;
  disabledValidTo?: boolean;
  validFromRequired?: boolean;
  validToRequired?: boolean;
};

export function ControlledValidFromValidTo(props: Props) {
  const {
    control,
    disabledValidFrom,
    disabledValidTo,
    variant = 'outlined'
  } = props;

  const { t } = useTranslation('common');

  return (
    <Grid container spacing={2.5}>
      <Grid item xs={6}>
        <ControlledDatePicker
          fullWidth
          variant={variant}
          name="validFrom"
          control={control}
          label={t('validFrom')}
          disabled={disabledValidFrom}
          required={props.validFromRequired}
        />
      </Grid>
      <Grid item xs={6}>
        <ControlledDatePicker
          fullWidth
          variant={variant}
          name="validTo"
          control={control}
          label={t('validTo')}
          disabled={disabledValidTo}
          required={props.validToRequired}
        />
      </Grid>
    </Grid>
  );
}

export default ControlledValidFromValidTo;
